import { isEmpty } from "../../utils/array.utils";

export function defaultCacheValueValidator(value: unknown): boolean {
	return value !== undefined;
}

export function defaultCacheArrayValueValidator(value: unknown): boolean {
	return value !== undefined && Array.isArray(value) && !isEmpty(value);
}

export function defaultCacheMidnightValidator(value: unknown): boolean {
	const now = new Date();
	const target = new Date();

	target.setHours(23, 59, 0, 0);

	return value !== undefined && now.getTime() <= target.getTime();
}
